import React from "react";
import { Navigate } from "react-router-dom";
import { useTribeAuth } from "@/context/TribeAuthContext";

export default function TribeProtectedRoute({ children }) {
  const { tribe, loading } = useTribeAuth();

  if (loading || tribe === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink">
        <div className="font-mono text-xs tracking-[0.3em] uppercase text-gold/70 animate-pulse">
          Verifying Nation Credentials
        </div>
      </div>
    );
  }

  if (!tribe) return <Navigate to="/tribes/login" replace />;
  return children;
}
